import { ElMessage } from "element-plus";
import { type AxiosInstance } from "axios";
import { Session } from "@/utils/session";
import { CustomRequest, InterceptorConfig } from "./request.d";
import store from "@/store";

export default function (instance: AxiosInstance) {
  // 添加请求拦截器
  instance.interceptors.request.use(
    (
      config: InterceptorConfig & {
        headers: CustomRequest.Header;
      }
    ) => {
      let url = config.url;
      // 白名单内不校验拦截器
      if (!url) {
        throw new Error("未配置请求url");
      }
      // 全局拦截器添加参数
      Object.assign(config.headers, {
        identity: store.state.userInfo?.identityType,
        appkey: store.state.userInfo?.appkey,
      });
      // 替换URL参数
      if (config.replacements) {
        for (const [key, value] of Object.entries(config.replacements)) {
          url = url.replace(`{${key}}`, value as string);
        }
        config.url = url;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  // 添加响应拦截器
  instance.interceptors.response.use(
    (res) => {
      console.log(res.data.code, typeof res.data.code);
      console.log("全局响应拦截器", res);
      if (res.data && typeof res.data.code !== "undefined") {
        const code = res.data.code;
        switch (code) {
          case "200":
          case 200:
          case 201:
            return Promise.resolve(res.data);
          case 401:
            // 登录失效删除本地缓存的系统ID
            Session.removeOrgId();
            window.location.replace(
              `${res.data.data.loginURL}?ReturnUrl=${encodeURIComponent(
                location.href
              )}`
            );
            break;
          case 402:
            // 跳转到老系统
            Session.removeOrgId();
            window.location.replace(process.env.VUE_APP_OLD_URL);
            break;
          default:
            ElMessage.error(res.data.message);
            throw code;
        }
      }
      return res;
    },
    (error) => {
      //请求超时提示
      if (error.message.includes("timeout")) {
        ElMessage.error("请求超时，请稍后重试");
      } else if (error.message === "canceled") {
        console.log("取消未完成请求");
      } else {
        ElMessage.error(error.message);
      }
      return Promise.reject(error);
    }
  );
}
